export class ZuersZone {
  zone: string | null;
  bach = "";
  kueste = "";
  starkregen = "";
  erdbebenzone = false;
}
